import { Round as ArrowRight } from '@manomano-internal/tamagoshi-icons/esm/material/KeyboardArrowRight';
import classnames from 'classnames';
import type { FunctionComponent, PropsWithChildren } from 'react';

import styles from './styles/ProBlock.module.scss';

export interface DummyProBlockProps extends PropsWithChildren {
  onClick: () => void;
  url: string;
}

export const DummyProBlock: FunctionComponent<DummyProBlockProps> = ({
  onClick,
  url,
  children,
}) => (
  <a
    className={classnames(styles.blockContainer, styles.backgroundImage)}
    href={url}
    data-url-login={url}
    data-testid="pro-block"
    data-gtm-event="click_b2b_login"
    data-gtm-target="product_page_info_cta"
    onClick={onClick}
  >
    {children}
    <div className={styles.arrowContainer}>
      <ArrowRight />
    </div>
  </a>
);
